module.exports = __webpack_public_path__ + "img/ar_action.d2831456.png";